import adsService from '../utils/adsService'

const sendAdsContact = (params: { email: string; phone: string }) => {
  adsService.send({
    conversion_value: 10.0,
    transaction_id: new Date().toString(),
    data: params,
  })
}

const sendAdsOnlineBooking = ({
  amount,
  email,
  phone,
}: {
  amount: number
  email: string
  phone: string
}) => {
  adsService.send({
    conversion_value: amount,
    transaction_id: new Date().toString(),
    data: {
      email,
      phone,
    },
  })
}

const sendAdsViewPhone = (params: { email: string }) => {
  adsService.send({
    conversion_value: 1.0,
    transaction_id: new Date().toString(),
    data: params,
  })
}

export { sendAdsContact, sendAdsOnlineBooking, sendAdsViewPhone }
